import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const TopBar = () => {
  const [searchActive, setSearchActive] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-[#0f0f0f] border-b border-gray-800 z-50 flex items-center justify-between px-4">
      <Link to="/" className="flex items-center gap-2">
        <img src="/ChaFreeBonusNow.png" alt="FreeBonusNow" className="h-8 w-auto" />
        <span className="text-sm font-bold text-white">FreeBonusNow</span>
      </Link>

      <button 
        onClick={() => setSearchActive(!searchActive)}
        className="p-2 text-gray-400 hover:text-white transition-colors"
      >
        <Search className="w-6 h-6" />
      </button>

      {searchActive && (
        <div className="absolute inset-0 bg-[#0f0f0f] flex items-center px-4 animate-in fade-in duration-200">
          <input 
            autoFocus
            type="text" 
            placeholder="Search for offers..."
            className="flex-grow bg-transparent border-none outline-none text-white text-lg"
          />
          <button onClick={() => setSearchActive(false)} className="p-2">
            <X className="w-6 h-6 text-gray-400" />
          </button>
        </div>
      )}
    </header>
  );
};

export default TopBar;
